import { useState } from "react";

const HIPAAComplianceForm = ({ setIsAgreed2 }) => {
  const [isAgreed, setIsAgreed] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsAgreed(e.target.checked);
    setIsAgreed2(e.target.checked);
  };

  return (
    <div
      className="row mx-0"
      style={{
        paddingLeft: "5px",
        paddingRight: "5px",
        overflow: "scroll",
        marginBottom: "5px",
        height: "440px",

        scrollbarWidth: "none",
      }}
    >
      <div
        className="col-md-12 p-0"
        style={{
          border: "1px solid #d3d3d3",
        }}
      >
        <div
          className="row mx-0 align-items-center"
          style={{
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          <div className="col-md-12 ps-0 text-start pe-0">
            <div className=" p-t-5 p-b-5">
              <div className=" text-white text-start">
                <h4 className="mb-0 fw-bold">
                  HIPAA Compliance & Attorney-Client Relationship Agreement
                </h4>
                <p className="mb-0 m-t-5 text-black">
                  Third-Party Application – Click-Through Agreement
                </p>
              </div>

              <div className="p-0">
                <p className="fw-bold">
                  This application provides access to Protected Health Information (PHI) regulated
                  under the Health Insurance Portability and Accountability Act of 1996 (HIPAA) and
                  other applicable privacy laws. Before proceeding, you must confirm your legal
                  authority to access this information and acknowledge the nature of your
                  professional relationship with the patient.
                </p>

                <p className="fw-bold">
                  By clicking I Agree, you acknowledge, represent, and agree to the following:
                </p>

                <div className="m-t-5">
                  <h5 className="text-primary fw-bold">1. Legal Authority to Access PHI</h5>
                  <p>
                    You certify that you are legally authorized to access patient information
                    through this third-party application. This authorization is based on one or more
                    of the following:
                  </p>
                  <ul className="ps-2">
                    <li>
                      • You are a licensed attorney or legal representative acting with the express,
                      written consent of the patient;
                    </li>
                    <li>
                      • You are acting as a personal representative legally appointed by the patient
                      or court;
                    </li>
                    <li>
                      • You are authorized through a valid HIPAA-compliant written release or legal
                      directive signed by the patient or their lawful representative.
                    </li>
                  </ul>
                </div>

                <div className="m-t-5">
                  <h5 className="text-primary fw-bold">2. Attorney-Client Relationship</h5>
                  <p>
                    You acknowledge that by accessing the patients confidential medical information
                    through this application, you are engaging in a protected attorney-client
                    relationship with the patient.
                  </p>
                  <p className="fw-bold">You agree and understand that:</p>
                  <ul className="ps-2">
                    <li>
                      • The information accessed is subject to both HIPAA protections and
                      attorney-client confidentiality;
                    </li>
                    <li>
                      • You will use this information solely for purposes related to your legal
                      representation or advocacy on behalf of the patient;
                    </li>
                    <li>
                      • You have a duty to safeguard both the legal and medical privacy rights of
                      the patient as protected under federal and state law;
                    </li>
                    <li>
                      • Any disclosures made to you by the patient or via this app are made within
                      the scope of legal representation and may be subject to privilege.
                    </li>
                  </ul>
                </div>

                <div className="m-t-5">
                  <h5 className="text-primary fw-bold">3. Permitted Uses and Disclosure</h5>
                  <p>You agree to use the PHI accessed only for lawful purposes consistent with:</p>
                  <ul className="ps-2">
                    <li>• The patients express authorization;</li>
                    <li>
                      • Representation in legal, administrative, or claims-related proceedings;
                    </li>
                    <li>
                      • Coordination with healthcare providers, insurers, or agencies strictly
                      within the scope of legal advocacy;
                    </li>
                    <li>
                      • Applicable privacy and professional conduct rules governing attorney
                      behavior.
                    </li>
                  </ul>
                </div>

                <div className="m-t-5">
                  <h5 className="text-primary fw-bold">4. Confidentiality and Safeguards</h5>
                  <p className="fw-bold">You agree to:</p>
                  <ul className="ps-2">
                    <li>
                      • Protect all PHI and other confidential data from unauthorized use or
                      disclosure;
                    </li>
                    <li>
                      • Use administrative, technical, and physical safeguards to secure information
                      in accordance with HIPAA;
                    </li>
                    <li>
                      • Not share, transmit, export, or store PHI except as legally permitted and
                      necessary for representation purposes.
                    </li>
                  </ul>
                </div>

                <div className="m-t-5">
                  <h5 className="text-primary fw-bold">5. Monitoring and Accountability</h5>
                  <p className="fw-bold">You understand and agree that:</p>
                  <ul className="ps-2">
                    <li>
                      • Your access to this application and its data is subject to monitoring and
                      audit;
                    </li>
                    <li>
                      • Unauthorized access, use, or sharing may result in suspension of access,
                      legal liability, disciplinary action, and/or referral to licensing bodies.
                    </li>
                  </ul>
                </div>

                <div className="m-t-5">
                  <h5 className="text-primary fw-bold">6. Personal Certification</h5>
                  <p>
                    You certify that all representations you have made regarding your identity,
                    legal authority, and role in accessing this data are true and accurate. You
                    affirm that you are acting in good faith, in accordance with applicable legal
                    and ethical standards.
                  </p>
                </div>

                <div className="m-t-5">
                  <h5 className="text-primary fw-bold">7. Consequences of Misuse</h5>
                  <p>
                    Unauthorized access or misuse of patient information is a violation of HIPAA,
                    attorney ethics rules, and applicable laws. It may subject you to civil
                    penalties, criminal prosecution, loss of access privileges, and potential
                    disbarment.
                  </p>
                </div>

                <div className="alert alert-danger m-t-5" role="alert">
                  <strong>
                    If you are not legally authorized to access this information or are not acting
                    within the bounds of a legitimate attorney-client relationship, do not proceed.
                  </strong>
                </div>

                <div className="m-t-5 p-2 border rounded bg-light">
                  <div className="d-flex align-items-center gap-1 m-b-5">
                    <input
                      className="form-check d-flex align-items-center justify-content-center mb-0 ps-0"
                      type="checkbox"
                      id="agreeCheckbox"
                      style={{
                        minWidth: "13px",
                        width: "13px",
                        height: "13px",
                      }}
                      checked={isAgreed}
                      onChange={handleCheckboxChange}
                    />
                    <label className="form-check-label mb-0 sfw-bold" htmlFor="agreeCheckbox">
                      I Agree
                    </label>
                  </div>

                  <p className="small m-b-5">
                    By checking this box and continuing, you affirm that you have read, understood,
                    and agreed to the above terms, including your role under HIPAA and your
                    engagement in a protected attorney-client relationship with the patient.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HIPAAComplianceForm;
